import { render, staticRenderFns } from "./CmpTcsUpload.vue?vue&type=template&id=084062dc&"
import script from "./CmpTcsUpload.vue?vue&type=script&lang=js&"
export * from "./CmpTcsUpload.vue?vue&type=script&lang=js&"
import style0 from "./CmpTcsUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports